import { FileTypeEnum } from "api/actor";
import logoConfiancia from "assets/images/icons/dashboard/logo-confiancia.svg";
import { DOCUMENT_TYPE_LABELS, DocumentType } from "features/subscription-process/pricing-process/components/funnel-card/models/funnelCardFooterModel"
import { FileIcon } from "lucide-react";
import { FC, useMemo } from "react"
import { useFunnelDownload } from "./useFunnelDownload";

interface FunnelCardHeaderProps {
  logoURL?: string
  title?: string
  productId?: string
}

export const BorrowerFunnelCardHeader: FC<FunnelCardHeaderProps> = ({ logoURL, title, productId }) => {
  const logo = logoURL || logoConfiancia
  const { isDownloading, setIsDownloading, onDownload } = useFunnelDownload()

  const renderProductDocument = useMemo(() => {
    return <div className="mt-auto min-h-[28px] flex items-end">
      <div
        className={`flex items-center gap-1 ${isDownloading === FileTypeEnum.FicheProduit ? 'opacity-50' : 'cursor-pointer'
          }`}
        onClick={() => !isDownloading && productId && onDownload(productId, FileTypeEnum.FicheProduit)}
      >
        <FileIcon className="w-4 h-4 text-primary" />
        <p className="text-primary cursor hover:underline">
          {isDownloading === FileTypeEnum.FicheProduit
            ? 'Téléchargement...'
            : DOCUMENT_TYPE_LABELS[DocumentType.SYS_CONDITIONS_SPECIALES]
          }
        </p>
      </div>
    </div>
  }, [productId, isDownloading, onDownload])

  return <div className="flex flex-col p-4 gap-2 items-center border-r w-36 2xl:w-[200px]">
    <div className="flex flex-col items-center justify-center gap-0.5 flex-1">
      <div className="flex items-center justify-center w-16 h-16">
        <img
          src={logo}
          alt="pic"
          className="max-w-full max-h-full object-contain"
          loading="lazy"
        />
      </div>
      <p className="text-sm text-center">{title}</p>
    </div>
    {renderProductDocument}
  </div>
}
